export default {
    'create-unit-size': 'Crear unidad',
    'edit-unit-size': 'Modificar unidad',

    'unit-size-name': 'Nombre de unidad de medición',
    'notes': 'Notas',

    save: 'Guardar',
    cancel: 'Cancelar',
    
    'delete-the-unit-size': 'Eliminar la unidad',
    'are-you-sure-you-want-to-delete-the-unit-size': '¿Estas seguro de eliminar la unidad?',

    headers: {
        'unit-size': 'Unidad',
        'notes': 'Notas',
        'actions': 'Acciones',
    }
}